module.exports = __webpack_public_path__ + "static/media/active-home.f982af09.svg";